import { render, staticRenderFns } from "./ModalExpressao.vue?vue&type=template&id=554af3f6&"
import script from "./ModalExpressao.vue?vue&type=script&lang=js&"
export * from "./ModalExpressao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports